import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import styles from './FlashSucess.module.scss';
import PropTypes from 'prop-types';

function FlashSuccess({
  isOpen,
  onClose,
  children,
  timeout = 3000,
}) {
  const [internalOpen, setInternalOpen] = useState(false);

  useEffect(() => {
    setInternalOpen(isOpen);
    if (isOpen) {
      document.body.classList.toggle('overflow-hidden');
      setTimeout(() => {
        setInternalOpen(false);
        if (onClose) {
          document.body.classList.toggle('overflow-hidden');
          onClose();
        }
      }, timeout);
    }
  }, [isOpen]);

  if (!internalOpen) return null;

  return (ReactDOM.createPortal(
    <div className={styles.FlashSuccess}>
      <Row className='align-items-center justify-content-center'>
        <Col xs={12} className={styles.content}>
          {children}
        </Col>
      </Row>
    </div>,
    document.body
  ));
}

FlashSuccess.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.any,
  timeout: PropTypes.number
};

FlashSuccess.defaultProps = {
  isOpen: false,
  onClose: () => { },
  children: null,
  timeout: 3000
};

export default React.memo(FlashSuccess);